const LogoSvg: React.FC = () => {
  return (
    <svg
      id="Groupe_84"
      data-name="Groupe 84"
      xmlns="http://www.w3.org/2000/svg"
      width="210.431"
      height="103.293"
      viewBox="0 0 210.431 103.293"
    >
      <defs>
        <clipPath id="clipPath">
          <rect
            id="Rectangle_69"
            data-name="Rectangle 69"
            width="210.431"
            height="103.293"
            fill="none"
          />
        </clipPath>
      </defs>
      <g id="Groupe_83" data-name="Groupe 83" clipPath="url(#clipPath)">
        <path
          id="Tracé_32"
          data-name="Tracé 32"
          d="M305.43,106.671c1.993,13.164-11.7,28.526-32.854,35.829-23.244,8.023-46.694,3.278-52.377-10.6a16.639,16.639,0,0,1-.629-1.838,16.633,16.633,0,0,0,1.218,5.464c5.68,13.87,29.2,18.584,52.544,10.528,23.161-7.995,37.432-25.56,32.1-39.383"
          transform="translate(-96.115 -46.694)"
          fill="#fff"
          fillRule="evenodd"
        />
        <path
          id="Tracé_33"
          data-name="Tracé 33"
          d="M64.089,20.067a19.845,19.845,0,1,1,39.688,0,19.845,19.845,0,1,1-39.688,0m34.838,0c0-8.7-6.634-15.552-14.994-15.552S68.995,11.372,68.995,20.067c0,8.639,6.577,15.5,14.938,15.5a15.149,15.149,0,0,0,14.994-15.5"
          transform="translate(-28.054 0)"
          fill="#fff"
        />
        <path
          id="Tracé_34"
          data-name="Tracé 34"
          d="M137.913,31.713c0-8.082,5.407-12.876,12.207-12.876,6.855,0,12.263,4.793,12.263,12.876v14.27a2.249,2.249,0,0,1-2.23,2.285,2.213,2.213,0,0,1-2.229-2.285V31.6c0-5.686-3.457-8.64-7.8-8.64-4.292,0-7.748,2.954-7.748,8.64V45.982a2.249,2.249,0,0,1-2.23,2.285,2.214,2.214,0,0,1-2.229-2.285Z"
          transform="translate(-60.37 -8.246)"
          fill="#fff"
        />
        <path
          id="Tracé_35"
          data-name="Tracé 35"
          d="M187.184,2.428A2.2,2.2,0,0,1,189.414.2a2.236,2.236,0,0,1,2.229,2.23V37.823a2.249,2.249,0,0,1-2.229,2.286,2.215,2.215,0,0,1-2.23-2.286Z"
          transform="translate(-81.938 -0.087)"
          fill="#fff"
        />
        <path
          id="Tracé_36"
          data-name="Tracé 36"
          d="M194.61,45.845V21.264a2.2,2.2,0,0,1,2.23-2.23,2.237,2.237,0,0,1,2.229,2.23v19.23l17.336-20.679a1.953,1.953,0,0,1,1.56-.78,2.071,2.071,0,0,1,2.119,2.062,2.1,2.1,0,0,1-.5,1.338L187.106,61.122a1.953,1.953,0,0,1-1.561.78,2.071,2.071,0,0,1-2.118-2.062,2.1,2.1,0,0,1,.5-1.338Z"
          transform="translate(-80.294 -8.332)"
          fill="#fff"
        />
        <path
          id="Tracé_37"
          data-name="Tracé 37"
          d="M0,88.729A19.8,19.8,0,0,1,19.844,68.663a19.535,19.535,0,0,1,15.106,7.023,2.561,2.561,0,0,1,.669,1.672,2.367,2.367,0,0,1-2.4,2.341,3.072,3.072,0,0,1-1.9-.947,14.537,14.537,0,0,0-11.482-5.573c-8.361,0-14.938,6.855-14.938,15.551,0,8.639,6.577,15.5,14.938,15.5a14.656,14.656,0,0,0,11.482-5.518,2.808,2.808,0,0,1,1.9-.948,2.333,2.333,0,0,1,2.4,2.342,2.432,2.432,0,0,1-.669,1.616A19.407,19.407,0,0,1,19.844,108.8,19.8,19.8,0,0,1,0,88.729"
          transform="translate(0 -30.057)"
          fill="#fff"
        />
        <path
          id="Tracé_38"
          data-name="Tracé 38"
          d="M65.208,102.27a14.688,14.688,0,1,1,14.715,14.771A14.539,14.539,0,0,1,65.208,102.27m24.86,0c0-5.909-4.4-10.647-10.145-10.647A10.659,10.659,0,1,0,90.068,102.27"
          transform="translate(-28.544 -38.302)"
          fill="#fff"
        />
        <path
          id="Tracé_39"
          data-name="Tracé 39"
          d="M122.023,100.374c0-8.082,5.407-12.876,12.207-12.876,6.856,0,12.263,4.793,12.263,12.876v14.27a2.249,2.249,0,0,1-2.229,2.285,2.214,2.214,0,0,1-2.23-2.285V100.262c0-5.686-3.456-8.64-7.8-8.64-4.292,0-7.748,2.954-7.748,8.64v14.381a2.249,2.249,0,0,1-2.229,2.285,2.214,2.214,0,0,1-2.23-2.285Z"
          transform="translate(-53.415 -38.302)"
          fill="#fff"
        />
        <path
          id="Tracé_40"
          data-name="Tracé 40"
          d="M164.564,80.095a2.058,2.058,0,0,1,2.062-2.062h2.954V66.83a2.2,2.2,0,0,1,2.23-2.229,2.168,2.168,0,0,1,2.229,2.229v11.2H181.4a2.058,2.058,0,0,1,2.063,2.062,2.094,2.094,0,0,1-2.063,2.062H174.04v12.6c0,5.184,2.954,7.971,7.357,7.971a2.091,2.091,0,0,1,0,4.181c-6.911,0-11.816-4.682-11.816-12.152v-12.6h-2.954a2.1,2.1,0,0,1-2.062-2.062"
          transform="translate(-72.037 -28.279)"
          fill="#fff"
        />
        <path
          id="Tracé_41"
          data-name="Tracé 41"
          d="M221.049,112.582a14.08,14.08,0,0,1-10.423,4.459,14.772,14.772,0,1,1,10.423-25.084V89.84a2.235,2.235,0,0,1,2.23-2.229,2.2,2.2,0,0,1,2.229,2.229v24.8a2.213,2.213,0,0,1-2.229,2.284,2.248,2.248,0,0,1-2.23-2.284Zm0-9.866v-.892a10.658,10.658,0,1,0,0,.892"
          transform="translate(-85.88 -38.302)"
          fill="#fff"
        />
        <path
          id="Tracé_42"
          data-name="Tracé 42"
          d="M252.907,102.27A14.539,14.539,0,0,1,267.622,87.5a14.153,14.153,0,0,1,10.87,4.793,2.6,2.6,0,0,1,.669,1.561,2.067,2.067,0,0,1-2.229,2.062,2.835,2.835,0,0,1-1.9-.947,9.712,9.712,0,0,0-7.413-3.345,10.656,10.656,0,0,0,0,21.293,9.8,9.8,0,0,0,7.413-3.344,2.78,2.78,0,0,1,1.9-1,2.111,2.111,0,0,1,2.229,2.118,2.593,2.593,0,0,1-.669,1.505,14.1,14.1,0,0,1-10.87,4.849,14.54,14.54,0,0,1-14.715-14.771"
          transform="translate(-110.708 -38.302)"
          fill="#fff"
        />
        <path
          id="Tracé_43"
          data-name="Tracé 43"
          d="M300,84.91a2.058,2.058,0,0,1,2.062-2.062h2.954V77.831a2.2,2.2,0,0,1,2.23-2.23,2.168,2.168,0,0,1,2.229,2.23v5.016h7.357a2.058,2.058,0,0,1,2.063,2.062,2.094,2.094,0,0,1-2.063,2.062h-7.357v12.6c0,5.184,2.954,7.971,7.357,7.971a2.091,2.091,0,0,1,0,4.181c-6.911,0-11.816-4.682-11.816-12.152v-12.6H302.06A2.1,2.1,0,0,1,300,84.91"
          transform="translate(-131.322 -33.094)"
          fill="#fff"
        />
      </g>
    </svg>
  );
};

export default LogoSvg;
